import React, { memo } from "react";
import { validators, formats } from "investira.sdk";
import { Dialog, DialogContent, AppBar, Toolbar, Icon, Typography, IconButton, Stack, Divider, Card, useMediaQuery } from "investira.react.components";
import { displays } from "investira.react.lib";
import ConcentracaoGraph from "../Concentracao/ConcentracaoGraph";
import AtivosEmissor from "./AtivosEmissor";
const EmissorDetalhesDialog = memo(props => {
  const {
    emissor,
    onSetEmissor
  } = props;
  const isUpMd = useMediaQuery(theme => theme.breakpoints.up("md"));
  const xDialogProps = isUpMd ? {
    fullScreen: true,
    maxWidth: "xl"
  } : {
    fullScreen: true,
    PaperProps: {
      sx: {
        margin: 0
      }
    }
  };
  const isOpen = !validators.isEmpty(emissor);
  if (!isOpen) {
    return null;
  }
  const xObservadoColor = emissor.grafico.alvo.targetColor;
  return <>
      <Dialog fullScreen open={isOpen} onClose={() => onSetEmissor({})} {...xDialogProps}>
        <AppBar sx={{
        position: "relative"
      }}>
          <Toolbar>
            <Typography sx={{
            flexGrow: 1
          }} variant="h6" component="div">
              {emissor.pessoa_fantasia}
            </Typography>
            <IconButton edge="end" color="primary" onClick={() => onSetEmissor({})} aria-label="close">
              <Icon iconName="cancel" size={21} />
            </IconButton>
          </Toolbar>
        </AppBar>
        <DialogContent sx={{
        display: "flex",
        px: 3
      }}>
          <Stack id="regraArea" flexGrow={1} sx={{
          width: "100%"
        }}>
            <Stack py={2}>
              <Typography variant="caption">
                <b>{emissor.descricao}</b> - {emissor.criterio.join(", ")}
              </Typography>
            </Stack>

            <Divider />
            <Stack py={2}>
              {emissor.cnpj && <Typography variant="caption">
                  <b>CNPJ:</b> {displays.cnpj(emissor.cnpj)}
                </Typography>}
              {emissor.top_setor && <Typography variant="caption">
                  <b>Setor:</b> {emissor.top_setor}
                </Typography>}
              {emissor.setor && <Typography variant="caption">
                  <b>Segmento:</b> {emissor.setor}
                </Typography>}
            </Stack>
            <Divider />
            <Stack py={2}>
              <ConcentracaoGraph range={emissor.grafico.range} minimo={emissor.grafico.minimo} alvo={emissor.grafico.alvo} observado={emissor.grafico.observado} enquadrado={emissor.grafico.enquadrado} targetColor={emissor.grafico.alvo.targetColor} />
            </Stack>

            <Stack sx={{
            gap: 2
          }} component="section" direction={{
            xs: "column",
            md: "row"
          }} pb={2}>
              {emissor.desenquadrado && <Card variant="outlined" sx={{
              display: "flex",
              flexGrow: 1
            }}>
                  <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
                    <Typography variant="caption" color="text.secondary" sx={{
                  fontWeight: 500
                }}>
                      Desenquadrado
                    </Typography>
                    <Stack direction="column" justifyContent="flex-end">
                      <Stack>
                        <Typography variant="h5" color={xObservadoColor}>
                          <b>
                            {emissor.desenquadrado && formats.formatNumber(emissor.desenquadrado, 2, true)}
                          </b>
                        </Typography>
                      </Stack>
                    </Stack>
                  </Stack>
                </Card>}

              {(emissor.minimo || emissor.maximo) && <Stack sx={{
              gap: 2,
              flexGrow: 1
            }} direction={"row"}>
                  {emissor.minimo && <Card variant="outlined" sx={{
                display: "flex",
                flex: 1
              }}>
                      <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
                        <Typography variant="caption" color="text.secondary" sx={{
                    fontWeight: 500
                  }}>
                          Mínimo (%)
                        </Typography>
                        <Stack direction="column" justifyContent="flex-end">
                          <Stack>
                            <Typography variant="h5" color="text.secondary">
                              <b>{emissor.minimo}</b>
                            </Typography>
                          </Stack>
                        </Stack>
                      </Stack>
                    </Card>}
                  {emissor.maximo && <Card variant="outlined" sx={{
                display: "flex",
                flex: 1
              }}>
                      <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
                        <Typography variant="caption" color="text.secondary" sx={{
                    fontWeight: 500
                  }}>
                          Máximo (%)
                        </Typography>
                        <Stack direction="column" justifyContent="flex-end">
                          <Stack>
                            <Typography variant="h5" color="text.secondary">
                              <b>{emissor.maximo}</b>
                            </Typography>
                          </Stack>
                        </Stack>
                      </Stack>
                    </Card>}
                </Stack>}

              <Card variant="outlined" sx={{
              display: "flex",
              flexGrow: 1
            }}>
                <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
                  <Typography variant="caption" color="text.secondary" sx={{
                  fontWeight: 500
                }}>
                    Observado
                  </Typography>
                  <Stack direction="column" justifyContent="flex-end">
                    <Stack>
                      <Typography variant="h5" color={xObservadoColor}>
                        <b>
                          {emissor.financeiro && formats.formatNumber(emissor.financeiro, 2, true)}
                        </b>
                      </Typography>
                    </Stack>
                  </Stack>
                </Stack>
              </Card>

              <Stack sx={{
              gap: 2,
              flexGrow: 1
            }} direction={"row"}>
                <Card variant="outlined" sx={{
                display: "flex",
                flex: 1
              }}>
                  <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
                    <Typography variant="caption" color="text.secondary" sx={{
                    fontWeight: 500
                  }}>
                      Observado (%)
                    </Typography>
                    <Stack direction="column" justifyContent="flex-end">
                      <Stack>
                        <Typography variant="h5" color={xObservadoColor}>
                          <b>
                            {emissor.observado && formats.formatNumber(emissor.observado, 6, true)}
                          </b>
                        </Typography>
                      </Stack>
                    </Stack>
                  </Stack>
                </Card>
                {emissor.alvo && <Card variant="outlined" sx={{
                display: "flex",
                flex: 1
              }}>
                    <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
                      <Typography variant="caption" color="text.secondary" sx={{
                    fontWeight: 500
                  }}>
                        Alvo (%)
                      </Typography>
                      <Stack direction="column" justifyContent="flex-end">
                        <Stack>
                          <Typography variant="h5" color="info.main">
                            <b>{emissor.alvo}</b>
                          </Typography>
                        </Stack>
                      </Stack>
                    </Stack>
                  </Card>}
              </Stack>
            </Stack>
            <AtivosEmissor ativos={Object.values(emissor.ativos)} />
          </Stack>
        </DialogContent>
      </Dialog>
    </>;
});
export default EmissorDetalhesDialog;
